/* JM Hero: plays the desktop or mobile video (if set) over the hero image.
   - Video source is chosen by screen width and swaps if the window crosses the breakpoint.
   - The image always shows first, so the banner is never empty while the video loads.
   - Skipped when the visitor prefers reduced motion. */
(function () {
  if (window.__jmHeroLoaded) return;
  window.__jmHeroLoaded = true;

  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function listen(query, fn) {
    if (query.addEventListener) query.addEventListener('change', fn);
    else if (query.addListener) query.addListener(fn);
  }

  function setup(root) {
    if (!root || root.__jmHero) return;
    var video = root.querySelector('[data-jm-hero-video]');
    if (!video) return;
    root.__jmHero = true;

    video.muted = true;
    video.addEventListener('loadeddata', function () {
      video.hidden = false;
    });

    function pick() {
      var desktopSrc = video.getAttribute('data-src-desktop');
      var mobileSrc = video.getAttribute('data-src-mobile');
      var src = mobileQuery.matches ? (mobileSrc || desktopSrc) : (desktopSrc || mobileSrc);

      if (!src || reduceMotion.matches) {
        video.hidden = true;
        video.removeAttribute('src');
        return;
      }
      if (video.getAttribute('src') !== src) {
        video.hidden = true;
        video.setAttribute('src', src);
        video.load();
      }
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    }

    pick();
    listen(mobileQuery, pick);
    listen(reduceMotion, pick);
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-jm-hero]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
